import { logSentry } from '@gto/sentry'

/**
 * Shared boundary coercion for optional wire PERCENTAGES (delta_pct fields).
 * `null` is the legitimate "no delta to render" signal — the BE omits the
 * `*_delta_pct` fields when the comparison window is unavailable, and
 * `DeltaIndicator` swallows `null` cleanly. A non-numeric/NaN value, however,
 * is a BE contract violation: without this guard `Number('abc')` becomes
 * `NaN`, which renders across ~14 KPI tiles as the literal string `"NaN%"`
 * with no observability signal.
 *
 * Mirror of `to-amount.ts` and `to-rate.ts` — same shape, same Sentry idiom.
 * Kept distinct so the Sentry grep distinguishes a delta-pct-shaped breach
 * from money- and rate-shaped ones.
 *
 * `logPrefix` identifies the surface (e.g.
 * `'admin-dashboard toNullablePct revenue_delta_pct:'`) so consumers can
 * attribute reports.
 */
export const toNullablePct = (
  value: number | string | null | undefined,
  logPrefix: string,
): number | null => {
  if (value == null) {
    return null
  }
  const n = Number(value)

  if (!Number.isFinite(n)) {
    logSentry(logPrefix, { value })

    return null
  }

  return n
}
